export default __webpack_public_path__ + "static/media/server_error.23f631f0.svg";